import React from "react";
import "react-quill/dist/quill.snow.css";

const Order = () => {
  return (
    <div>
      <div
        className="contact-associated-table "
        style={{
          textAlign: "center",
          fontWeight: "700",
          // border: "4px solid black",
        }}
      >
        <p>Thank you for your interest in our Safety Mailing service.</p>
        <p>
          Unfortunately, we are no longer accepting new orders for this year's
          Safety Mailings.
        </p>
        <p>
          Please email{" "}
          <u>
            <a
              href="mailto:Daniel@stonecore.com"
              style={{ color: "#478ec", textDecoration: "underline" }}
            >
              Daniel@stonecore.com
            </a>
          </u>{" "}
          to be added to our list to be contacted for next year’s Mailings
        </p>
      </div>
    </div>
  );
};

export default Order;
